import { create } from 'zustand';
import { Cursor } from '../types';

interface CursorStore {
  cursors: Record<string, Cursor>;
  setCursor: (uid: string, cursor: Cursor) => void;
  removeCursor: (uid: string) => void;
  clearCursors: () => void;
}

export const useCursorStore = create<CursorStore>((set) => ({
  cursors: {},
  setCursor: (uid, cursor) =>
    set(s => ({ cursors: { ...s.cursors, [uid]: cursor } })),
  removeCursor: (uid) =>
    set(s => {
      const cursors = { ...s.cursors };
      delete cursors[uid];
      return { cursors };
    }),
  clearCursors: () => set({ cursors: {} }),
}));